import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PushMessageEndpoint } from '@m4u-angular/core/endpoints/push-message.endpoint';
import { BaseComponent } from '../../../base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '../../../base/component/ServiceBag';
import { BaseState } from '../../../base/entities/BaseEntities';

class State extends BaseState {
    IsLoadAllNotifications: boolean;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-push-message-list-popup',
    templateUrl: './push-message-list-popup.component.html',
    styleUrls: ['./push-message-list-popup.component.scss']
})
export class PushMessageListPopupComponent extends BaseComponent<State> {

    @Input() Visible: boolean;
    @Output() VisibleChange = new EventEmitter<boolean>();

    @Input() PositionTarget: string;

    constructor(A: ServiceBagService,
        private pushMessageEndpoint: PushMessageEndpoint) {
        super(A, 'PushMessageListPopupComponent', State);
        console.log('PushMessageListPopupComponentPushMessageListPopupComponentPushMessageListPopupComponent')
    }

    OnOptionChanged(e) {
        if (e.name === 'visible') this.VisibleChange.emit(e.value);
    }

    OnLoadAllNotifications(value: boolean) {
        this.State.IsLoadAllNotifications = value;
    }

    OnHidden() {
        this.State.IsLoadAllNotifications = false;
    }
}
